import { render, staticRenderFns } from "./AffiliateLink.vue?vue&type=template&id=e96429b4"
import script from "./AffiliateLink.vue?vue&type=script&lang=ts"
export * from "./AffiliateLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports